import * as React from "react";
import {
  Box, Container, Typography,
} from "@mui/material";
import ButtonComponent from "components/Button";
import PropTypes from "prop-types";
import {
  schema,
  getButtonDataSendApproved,
  getButtonDataSendDisable,
  getButtonDataSendDelete,
  getButtonData,
  getTextfieldData
} from "./helper";
import {checkUserAllowed, getImage, getLocalDate, openURL} from "helpers/utils";
import {H2, H4, H5} from "components/CustomTypography";
import TextFieldComponent from "components/TextField";
import {DATE_FORMAT, DATE_TIME_FORMAT_SHORT} from "config/constants";
import ImageAlbum from "components/elements/main/ImageAlbum";
import AdminShopSupportTicketList from "components/elements/admin/shops/AdminShopSupportTicketList";
import AdminSellerShopDetail from "components/elements/admin/shops/AdminSellerShopDetail";

import {useState} from "react";
import CustomSectionCreator from "components/CustomSectionCreator";
import ShopHeaderBack from "components/elements/main/ShopHeaderBack";
import AdminProductSearch from "components/widgets/admin/AdminProductSearch";

const AdminShopSupportTicketSettingEditor = (props) => {

  const {
    updateSaleLogSettingClicked, cancelEdit, isLoading, userDetails, history, selectedSaleLog,
        onCancel, saleslog
  } = props;

  const {
     _id,
  } = selectedSaleLog;



  const [saleslogModeState, setSaleLogModeState] = useState("PREVIEW");


  const onFinishApproved = () => {
    updateSaleLogSettingClicked({
      saleslog_id: _id, status: "done"
    });
  };

  const handleShopButtonClick = () => {
    setSaleLogModeState("SHOP_DETAIL");
  };

  const handleProductButtonClick = () => {
    setSaleLogModeState("EDIT_PROD");
  };

  const renderSalesLogUpdates = () => (
      <>
        <Box>
          {saleslog.status !== "done" && ((checkUserAllowed(userDetails.userlevel, "saleslogapprove"))) &&
              getButtonDataSendApproved(onFinishApproved).map((element) => (
                  <ButtonComponent
                      type={element.type}
                      variant={element.variant}
                      onClick={element.onClick}
                      disabled={element.disabled}
                      name={element.name}
                      size="small"
                  />
              ))
          }

        </Box>
      </>
  );


  const renderSaleLogEntry = () => (
      <Container>
        <Box mb={2}>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Status:</H5>
            </Box>
            <Box width="70%">
              {saleslog.status}
            </Box>
          </Box>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Log Created:</H5>
            </Box>
            <Box width="70%">
              {getLocalDate(saleslog.created_at, DATE_TIME_FORMAT_SHORT)}
            </Box>
          </Box>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Shop Created:</H5>
            </Box>
            <Box width="70%">
              {saleslog.shop && getLocalDate(saleslog.shop.created_at, DATE_TIME_FORMAT_SHORT)}
            </Box>
          </Box>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Message:</H5>
            </Box>
            <Box width="70%">
              {saleslog.message}
            </Box>
          </Box>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Type:</H5>
            </Box>
            <Box width="70%">
              {saleslog.type}
            </Box>
          </Box>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Name</H5>
            </Box>
            <Box width="70%">
              {saleslog.shop && saleslog.shop.title}
            </Box>
          </Box>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Shop</H5>
            </Box>
            <Box width="70%">
              <ButtonComponent
                  type="primary"
                  variant="outlined"
                  name="View Shop"
                  size="small"
                  onClick={handleShopButtonClick}
              />
            </Box>
          </Box>
          <Box mb={2}>
            <ImageAlbum images={saleslog.images} mainOnly={true} />
          </Box>
          <Box width="100%" mb={2} alignItems="center" display="flex">
            <Box width="30%" >
              <H5 fontSize={14} textAlign="left" ellipsis>Products</H5>
            </Box>
            <Box width="70%">
              <ButtonComponent
                  type="primary"
                  variant="outlined"
                  name="View Products"
                  size="small"
                  onClick={handleProductButtonClick}
              />
            </Box>
          </Box>
        </Box>
        {(checkUserAllowed(userDetails.userlevel, "saleslogapprove")) && renderSalesLogUpdates()}

        {saleslog.shop && <AdminShopSupportTicketList shopId={saleslog.shop._id} />}
      </Container>
  );

  const renderCategoryEdit = () => {
    switch (saleslogModeState) {

      case "SHOP_DETAIL":
        return (
            <>
              <CustomSectionCreator isSubtle={true} title="Shop Information" />
              <ShopHeaderBack  {...props} onCancel={() => setSaleLogModeState("PREVIEW")} />
              {saleslog.shop && <AdminSellerShopDetail {...props} shopId={saleslog.shop._id}/>}
            </>
        );

      case "EDIT_PROD":
        return (
            <>
              <CustomSectionCreator isSubtle={true} title="Shop Products" />
              <ShopHeaderBack  {...props} onCancel={() => setSaleLogModeState("PREVIEW")} />
              {saleslog.shop &&
                  <AdminProductSearch {...props}
                                      shopId={saleslog.shop._id}
                                      isShop={true}
                  />}
            </>
        );
    }
  }

  return (
      <Container>
        {saleslogModeState === "PREVIEW" ? (
            <>
                <CustomSectionCreator isSubtle={true} title="Shop Support Ticket" />
              <ShopHeaderBack  {...props} onCancel={onCancel} />
                {renderSaleLogEntry()}
            </>
        ) : (
            renderCategoryEdit(saleslogModeState)
        )}
      </Container>
  );
};

AdminShopSupportTicketSettingEditor.propTypes = {
  setState: PropTypes.func.isRequired,
  offer: PropTypes.object.isRequired,
  updateOfferSettingClicked: PropTypes.func.isRequired,
  cancelEdit: PropTypes.func.isRequired,
};

export default AdminShopSupportTicketSettingEditor;
